module.exports = __webpack_public_path__ + "img/hu.e1f69ed4.jpg";